type FormType = {
    name: string;
    category: string;
    id: number;
  };
  
  export const formType: FormType[] = [
    { name: "Select Type", category: "", id: 1 },
    { name: "Notification Only", category: "N", id: 2 },
    { name: "Notification for Approvers", category: "NA", id: 3 },
    { name: "Notification for Pullback", category: "B", id: 4 },
    { name: "Transaction(Approve)", category: "A", id: 5 },
    { name: "Transaction(Reject)", category: "R", id: 6 }
  ];

  export type ModulePage = {
    ModulePageId?: number;
    ModulePageName: string;
  };

  export const getDefaultTemplateDetails = () => ({
    name: "",
    description: "",
    module: "",
    subject: "",
    subjectFields: "",
    type: "",
    fields: "",
    createdBy: 1430,
    employer: 10,
    active: "Y",
    wfNodes: "",
    wfId: 0,
    templateHtml: "",
    pageModuleId: 0
  });
  
    